module.exports = __webpack_public_path__ + "img/icon_fast_delivery_c.04e3147.svg";